import { useState } from 'react'
import { useNavigate } from 'react-router'
import { formatDate } from '@/lib/shipment'
import { Subscription, FlowerCollectionProduct, SubscriptionPlacement } from '~/api-client/data-contracts'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { useConfirmationModal } from '~/components/subscription/confirmation-modal'
import { Panel } from '~/components/subscription/panel'
import info from './info.svg'

// 次回のお届けに追加済みの合わせ買いグッズを表示する
export const InBulkCard: React.FC<{
  subscription: Subscription
  product: FlowerCollectionProduct
  inBulkProducts: FlowerCollectionProduct[]
  placements: SubscriptionPlacement[]
}> = ({ subscription, product, inBulkProducts, placements }) => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { confirm, confirmationModal } = useConfirmationModal()

  if (!subscription) return null

  const date = formatDate(subscription.attributes.next_deliver_at * 1000, 'M/d（E）')
  const status = placements[0]?.attributes?.status
  const price = product.attributes.bulk_discounted_price + inBulkProducts.reduce((sum, item) => sum + item.attributes.bulk_discounted_price, 0)

  const handleCancel = async () => {
    if (!(await confirm('次回お届けのグッズをキャンセルします。よろしいですか？'))) return

    const client = createClient(Subscriptions)
    setIsSubmitting(true)

    try {
      await Promise.all(inBulkProducts.map((p) => client.deleteSubscriptionsSubscriptionIdInBulkProductsId(subscription.id, p.id)))
      navigate(0) // reload
    } catch (error: any) {
      alert(error.response?.data?.error?.message_displayable ?? 'エラーが発生しました')
    } finally {
      setIsSubmitting(false)
    }
  }

  if (status === 'skipped' || inBulkProducts.length === 0) return null

  return (
    <Panel>
      <h3 className="text-[15px] font-bold text-black leading-relaxed">{date}はこちらのグッズを一緒にお届け</h3>
      <div className="flex items-start gap-1 text-[12px] text-[#828282] leading-relaxed">
        <img src={info} className="w-3.5 h-3.5 mt-0.5 shrink-0" />
        次回は通常の定期便代金 + グッズの代金の合計{Intl.NumberFormat().format(price)}円が請求されます
      </div>
      <div className="flex flex-col items-start gap-4">
        <div className="flex flex-wrap gap-2">
          {inBulkProducts.map((item) => (
            <div key={item.id} className="flex items-center gap-2">
              <img src={item.attributes.image_small_url} className="w-12 h-12 object-cover rounded-lg" />
              <div>
                <p className="text-[13px] text-black leading-relaxed">{item.attributes.name}</p>
                <p className="text-[13px] font-bold text-black">{Intl.NumberFormat().format(item.attributes.bulk_discounted_price)}円</p>
              </div>
            </div>
          ))}
        </div>
        <button
          type="button"
          disabled={isSubmitting}
          onClick={handleCancel}
          className="inline-block px-4 py-2 bg-black text-white text-[13px] font-bold rounded-full cursor-pointer"
        >
          グッズをキャンセル
        </button>
      </div>
      {confirmationModal}
    </Panel>
  )
}
